export default __webpack_public_path__ + "static/new7-06-812821a078480d0ff4d79568cba79bfc.jpg";